import Controller from "./formStepper.controller";
import template from "./formStepper.html";

const slidingSteps = {
  template,
  controller: Controller,
  transclude: true,
  bindings: {
    model: "<",
    confirmEvent: "<",
    switchViewAction: "<",
    onClickForward: "<?",
  },
};

export default slidingSteps;



// WEBPACK FOOTER //
// ./src/components/formStepper/formStepper.component.js